import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';

const MultiBarChats = ({ dataItems }) => {
  const [data, setData] = useState(dataItems);
  const [selectedGroup, setSelectedGroup] = useState('104'); // Default groupId for 'Dealer'
  
  const categoriesData = data && data.dates;

  const formattedDates = categoriesData.map(date => {
    const [year, month, day] = date.split('-');
    return `${day}-${month}-${year}`;
});

  // Function to handle group selection
  const handleGroupChange = (e) => {
    setSelectedGroup(e.target.value);
  };

  // Get the seriesData based on selected group
  const seriesData = data && data.userGroups
    ? data.userGroups.find(group => group.groupId === selectedGroup)?.reports
    : [];

  // Transform the data
  const transformedData = seriesData && seriesData.map(item => ({
    name: item.name,
    data: item.views, // Using the views from the selected group
  }));

  const options = {
    chart: {
      type: 'bar',
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: formattedDates,
    },
    yaxis: {
      title: {
        text: '$ (thousands)',
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} number of views`,
      },
    },
  };

  const series = transformedData || [];

  // Generate options for the select box (based on group names)
  const groupOptions = data && data.userGroups.map(group => (
    <option key={group.groupId} value={group.groupId}>
      {group.groupName}
    </option>
  ));

  return (
    <div>
      <div>
        <select id="group-select" value={selectedGroup} onChange={handleGroupChange}>
          {groupOptions}
        </select>
      </div>

      <div id="chart">
        <ReactApexChart options={options} series={series} type="bar" height={350} />
      </div>
    </div>
  );
};

export default MultiBarChats;
